import   React    ,
       { useState }  from 'react';

import   classNames  from 'classnames';

import   styles       from './BankChoice.module.scss';

import   Trigger      from '../../widget/actuators/Trigger';
import   Box           from '../../widget/windows/Box';

export interface BankChoiceProps {
  onCancel: () => void;
  onValidate: (bankCode: string) => void;
}

// Seul Paypal (bankCode '02') est actif aujourd'hui (Bank.active, cf.
// BankProcessorFactory) : Stripe existe côté backend mais reste désactivé faute de
// vraie clé (cf. claude/achats-quotas-createur-2026-09-07.md) ; Google Pay et Apple Pay
// n'ont aucune intégration — ce sont des portefeuilles, pas des passerelles, il leur
// faudrait un PSP derrière (voir la même note). Les trois affichent donc un message
// "bientôt disponible" au lieu d'appeler le backend, plutôt que de laisser échouer un
// vrai appel réseau (Stripe) ou d'en tenter un qui n'existe même pas côté serveur
// (Google/Apple Pay, pas de Bank ni de bankCode).
//
// Logos (public/images/payments/Logo-*) : PayPal, Google Pay, Apple Pay proviennent des
// kits de marque officiels (paypal-corp.com, developers.google.com/pay,
// developer.apple.com/apple-pay). Mastercard et Visa n'ont pas pu être récupérés depuis
// leurs portails de marque par ce moyen (accès bloqué, 403 — probablement réservé aux
// marchands identifiés) ; les fichiers utilisés ici ont été fournis autrement.
const UNAVAILABLE_LABEL: Record<string, string> = {
  stripe:    'Le paiement par carte',
  googlePay: 'Google Pay',
  applePay:  'Apple Pay',
};

export const BankChoice: React.FC<BankChoiceProps> = ({ onCancel, onValidate }) => {

  const [ unavailable, setUnavailable ] = useState<string | null>(null);

  if (unavailable) {
    return (
      <Box onClose={onCancel} width="380px" marginTop="16px">
        <div className={classNames(styles.root)}>
          <div className={classNames(styles.title)}>
            {unavailable} sera bientôt disponible.
          </div>
          <div className={classNames(styles.buttons)}>
            <Trigger name="Fermer" onClick={onCancel} />
          </div>
        </div>
      </Box>
    );
  }

  return (
    <Box onClose={onCancel} width="380px" marginTop="16px">
      <div className={classNames(styles.root)}>

        <div className={classNames(styles.title)}>
          Choix du moyen de paiement
        </div>

        <div className={classNames(styles.paymentGrid)}>

          <button
            className={classNames(styles.paymentButton, styles.paypal)}
            onClick={() => onValidate('02')}
          >
            <img className={classNames(styles.paypalLogo)} src="/images/payments/Logo-paypal.png" alt="PayPal" />
          </button>

          <button
            className={classNames(styles.paymentButton, styles.cardNetworks)}
            onClick={() => setUnavailable(UNAVAILABLE_LABEL.stripe)}
          >
            <img className={classNames(styles.cardNetworksLogo)} src="/images/payments/Logo-Visa-1.png" alt="Visa" />
            <img className={classNames(styles.cardNetworksLogo)} src="/images/payments/Logo-Master-Card.svg" alt="Mastercard" />
            <img className={classNames(styles.cbLogo)} src="/images/payments/Logo-CB.png" alt="Carte Bancaire" />
          </button>

          <button
            className={classNames(styles.paymentButton, styles.googlePay)}
            onClick={() => setUnavailable(UNAVAILABLE_LABEL.googlePay)}
          >
            <img className={classNames(styles.googlePayLogo)} src="/images/payments/Logo-Google-pay.png" alt="Google Pay" />
          </button>

          <button
            className={classNames(styles.paymentButton, styles.applePay)}
            onClick={() => setUnavailable(UNAVAILABLE_LABEL.applePay)}
          >
            <img className={classNames(styles.applePayLogo)} src="/images/payments/Logo-Apple-pay.svg" alt="Apple Pay" />
          </button>

        </div>

        <div className={classNames(styles.cancel)}>
          <Trigger name="Annuler" onClick={onCancel} />
        </div>

      </div>
    </Box>
  );
};

export default BankChoice;
